import { render } from "./ModalInfo.vue?vue&type=template&id=8be09f3a&scoped=true"
import script from "./ModalInfo.vue?vue&type=script&lang=js"
export * from "./ModalInfo.vue?vue&type=script&lang=js"

import "./ModalInfo.vue?vue&type=style&index=0&id=8be09f3a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be09f3a"]])

export default __exports__